module.exports = __webpack_public_path__ + "static/media/pickup.9edf08e0.svg";